module.exports = __webpack_public_path__ + "media/images/sports_icons/golf-e3dbb06226f03f8b3e3970a1646fe975.png";